import {
  FilterOptions,
  FilterRecord
} from "@pathwright/ux/src/components/filter/types"
import { transformFilterOptionsToGQLFilters } from "@pathwright/ux/src/components/filter/utils"
import { PathQueryVariables } from "@pathwright/graphql-client/src/generated"

export const navigatorPathFilters = {
  archived_time: "date"
} as const satisfies FilterRecord

export type NavigatorPathFilters = FilterOptions<
  typeof navigatorPathFilters
> | null

// Unified function to get the query variables for path queries.
export function getPathQueryVariables({
  pathId = null,
  userId = null,
  cohortId,
  navigatorPathFilters: navigatorPathFiltersState
}: {
  pathId?: number | null
  userId?: number | null
  cohortId: number
  navigatorPathFilters: NavigatorPathFilters
}): PathQueryVariables {
  // TODO: the transformed value is not typed very well: Record<string, Record<GQLFilterExpression, any>[]>
  const filterVariables = navigatorPathFiltersState
    ? transformFilterOptionsToGQLFilters(
        navigatorPathFilters,
        navigatorPathFiltersState
      )
    : null

  return {
    id: pathId,
    user_id: userId,
    cohort_id: cohortId,
    // When intention is to include archived items, we load items that are either archived or not archived.
    // Otherwise, we only load non-archived items (which is the default behavior).
    // Omitting the archivedDateFilter in that case to mirror other path queries in the platform.
    archivedDateFilter: filterVariables?.archived_time
  }
}
